import styled from './styled';

export const RegularText = styled.Text`
  color: #5a5a5a;
  font-size: 16px;
`;
